/**
 * Cookie helpers — thin wrappers for non-sensitive client flags we don't want
 * in localStorage (compliance, UI preferences). The server never reads these;
 * they're set client-side with Secure + SameSite=Lax.
 */
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export function setCookie(name, value, maxAgeSeconds = ONE_YEAR_SECONDS) {
  try {
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax${secure}`;
  } catch (err) {
    console.warn("setCookie failed", err);
  }
}

export function getCookie(name) {
  try {
    const prefix = `${name}=`;
    const pair = document.cookie
      .split("; ")
      .find((c) => c.startsWith(prefix));
    return pair ? decodeURIComponent(pair.slice(prefix.length)) : null;
  } catch (err) {
    console.warn("getCookie failed", err);
    return null;
  }
}
